import React from 'react';
import {Control, Controller, FieldValues, Path} from 'react-hook-form'
import {Hidden, Label, StyledRadio, RadioIcon, LabelText} from './styles.js'

type RadioButtonProps<T> = {
    label: string;
    name: string;
    isSelected: boolean | undefined;
    onChange: () => void;
    value: string | number;
    style?: string;
    isDisabled?: boolean;
    onAnswerClick?: (id: string | number) => void;
    id?: any;
};
export const RadioButton = <T extends FieldValues>({
    label,
    name,
    isSelected,
    onChange,
    value,
    isDisabled = false,
}: RadioButtonProps<T>) => {


    const onRadioClicked = () => {}

    return (
        <Label>
            <Hidden
                type='radio'
                name={name as string}
                checked={isSelected}
                onClick={onRadioClicked}
                value={value}
                onChange={onChange}
                disabled={isDisabled}
            />
            <StyledRadio isSelected={isSelected}>
                <RadioIcon name='Check' xSmall />
            </StyledRadio>

            <LabelText
                className={`${isSelected ?  'active' : ''}`}
                isDisabled={isDisabled}
            >
                {label}
            </LabelText>
        </Label>
    );
};

type RadioButtonGroupProps<T extends FieldValues, P extends Path<T>> = {
    control: Control<T>;
    name: P | string;
    options: string[];
    style?: string;
    isDisabled?: boolean;
    onAnswerClick?: (id: string | number) => void;
};

const Radio = <T extends FieldValues, P extends Path<T>>({
    name,
    options,
    control,
    style,
    onAnswerClick,
}: RadioButtonGroupProps<T, P>) => {

    return (
        <Controller
            name={name as P}
            control={control}
            render={({ field: { onChange, value = '' } }) => {
                return (
                    <>
                        {options.map((opt = '', index) => {

                            let isSelected = false;
                            isSelected = value === opt

                            return <RadioButton
                                key={index}
                                name={name}
                                id={index}
                                value={opt}
                                label={opt}
                                isSelected={isSelected}
                                onChange={onChange}
                                style={style}
                                onAnswerClick={onAnswerClick}
                                // isDisabled={opt.isDisabled || isDisabled}
                            />
                        })}
                    </>
                );
            }}
        />
    );
};

export default Radio